module.exports = __webpack_public_path__ + "static/media/back-grass.c4a2055f.png";